import { createAction } from 'redux-actions'

export const createLoadingAction = (name, indicator) => createAction(name, payload => payload, () => ({ indicator }))
export const createFeatureUsageAction = (name, limitName) => createAction(name, payload => payload, () => ({
  increaseFeatureUsageCount: true,
  limitName
}))
